<template>
  <div v-if="geolevelselected !== null">
    <el-menu id="geoLevelSelector" mode="horizontal" :unique-opened="true" menu-trigger="click" @open="menuOpened = true">
      <el-submenu index="1" class="fake-selector">
        <template slot="title">
          <span>{{ $t(geolevelselected.literalLevelname) }}: {{ geolevelselected.name }}</span> <em class="el-icon-arrow-down" />
        </template>
        <el-menu-item v-for="item in geolevels" :key="item.id" :label="$t(item.literalLevelname) + ': ' + item.name" :value="item.id" class="geoselector_option" @click="selectGeoItem(item.id)">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 11px; margin-left: 35px">{{ $t(item.literalLevelname) }}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GeographicalLevelSelector',
  components: {},
  props: {
    tituloVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // namespaceKey: this.$route.path.replaceAll('/', '')
    }
  },
  computed: {
    ...mapState('location', {
      geolevels: (state) => state.geolevels,
      geolevelselected: (state) => state.geolevelselected
    })
  },
  watch: {},
  methods: {
    selectGeoItem(id) {
      this.geolevelid = id
      const geocontry = this.geolevels.filter((item) => item.id === id)[0]
      if (geocontry !== undefined && geocontry !== null) {
        this.$store.dispatch('location/setgeolevel', geocontry)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
